import {
  getAccessToken,
  setTokens,
  clearTokens,
  getRefreshToken,
  refreshToken,
  checkToken,
} from './tokenHandling'
import { formatDateForBootcamp } from './bootcamps'
import duration from './duration'
import {
  getBackgroundImg,
  getLearningPathBackground,
  getGradient,
  getInstructorImg,
} from './imageHandling'
import { ineErrorHandler, rmotrErrorHandler } from './errorHandling'
import workbooks from './workbooks'
import countryCodes from './countryCodes'
import isPasswordValid from './isPasswordValid'
import {
  hasBaseAccess,
  isFreeContent,
  hasContentAccess,
  hasElevatedRoles,
} from './accessControl'
import {
  formatSubDate,
  getDaysRemainingForSub,
  isBusinessPlan,
  getSubType,
} from './subscriptions'
import { validateForm, clearFormErrors } from './formValidation'

function lazyLoadComponent({ componentFactory, loading, loadingData }) {
  let resolveComponent

  return () => ({
    component: new Promise(resolve => {
      resolveComponent = resolve
    }),
    loading: {
      mounted() {
        if (!('IntersectionObserver' in window)) {
          componentFactory().then(resolveComponent)
          return
        }

        const observer = new IntersectionObserver(entries => {
          if (entries[0].intersectionRatio <= 0) return
          observer.unobserve(this.$el)
          componentFactory().then(resolveComponent)
        })
        observer.observe(this.$el)
      },
      render(createElement) {
        return createElement(loading, loadingData)
      },
    },
  })
}

const buildContentLink = (type, content) => {
  const { id, objectID, slug, learning_areas: areas } = content
  const params = {
    area: areas && areas[0] ? areas[0].name.replace(/\s+/g, '') : 'INE',
    slug: slug && slug.length ? slug : 'ine-content',
  }
  if (type === 'path' || type === 'bootcamp') {
    params.id = objectID && objectID.length ? objectID : id
  } else {
    params.id =
      objectID && objectID.length ? objectID.slice(0, 8) : id.slice(0, 8)
  }
  return {
    name: `learning-area-${type}`,
    params,
  }
}

const shortenUUIDs = ids => {
  if (!Array.isArray(ids)) return ids
  const shortenIds = ids.map(id => id.split('-')[0])
  return shortenIds
}

const truncateText = (value, maxLength) => {
  if (value.length >= maxLength) {
    return `${value.substr(0, maxLength)}...`
  }
  return value
}

export {
  getAccessToken,
  getRefreshToken,
  setTokens,
  clearTokens,
  refreshToken,
  checkToken,
  lazyLoadComponent,
  formatDateForBootcamp,
  duration,
  getBackgroundImg,
  getLearningPathBackground,
  getGradient,
  buildContentLink,
  getInstructorImg,
  ineErrorHandler,
  rmotrErrorHandler,
  workbooks,
  countryCodes,
  isPasswordValid,
  shortenUUIDs,
  hasBaseAccess,
  isFreeContent,
  hasContentAccess,
  formatSubDate,
  getDaysRemainingForSub,
  isBusinessPlan,
  getSubType,
  validateForm,
  clearFormErrors,
  hasElevatedRoles,
  truncateText,
}
